<template>
  <b-modal v-model="visible" title="Edycja konta kursanta" @ok="onOk" @show="onShow">
    <div class="container">
      <b-row>
        <b-form class="col-md-12" @submit.prevent="onSubmit">
          <b-form-group class="required" label="Nr telefonu">
            <b-form-input
              v-model="phoneNumber"
              type="text"
              autocomplete="off"
              :state="$v.phoneNumber.$error? false : null"
              @input="$v.phoneNumber.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.phoneNumber.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Skype">
            <b-form-input
              v-model="skype"
              type="text"
              autocomplete="off"
              :state="$v.skype.$error? false : null"
              @input="$v.skype.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.skype.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Domyślna cena za makrocykl [PLN]">
            <b-form-input
              v-model="monthlyPrice"
              type="text"
              autocomplete="off"
              :state="$v.monthlyPrice.$error? false : null"
              @input="$v.monthlyPrice.$reset()"
              @keypress="onlyForCurrency"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.monthlyPrice.isCorrectDecimal">Wpisana wartość jest niepoprawna</div>
              <div v-if="!$v.monthlyPrice.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Opis">
            <b-form-textarea v-model="description" rows="3" max-rows="6" autocomplete="off" />
          </b-form-group>
        </b-form>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";

function replaceCommasWithDots(value){
      let valueString = value + "";
      return valueString.split(",").join(".");
}

const greaterThanZero = value => value > 0;
const isCorrectDecimal = (value) => {
      let monthlyPriceWithDotsString = replaceCommasWithDots(value);

      if (value == null ||(monthlyPriceWithDotsString.indexOf(".") > -1 && monthlyPriceWithDotsString.split(".")[1].length > 2)) {
        return false;
      }else if(monthlyPriceWithDotsString < 0){
        return false;
      }

      return true;
};

export default {
  data() {
    return {
      visible: false,
      id: null,
      phoneNumber: null,
      skype: null,
      description: null,
      monthlyPrice: null
    };
  },
  props: ["student"],
  validations: {
    phoneNumber: { required },
    skype: { required },
    monthlyPrice: { required, isCorrectDecimal }
  },
  methods: {
    show() {
      this.visible = true;
    },
    onShow() {
      this.$v.$reset();

      if (this.student) {
        this.id = this.student.id;
        this.phoneNumber = this.student.phoneNumber;
        this.skype = this.student.skype;
        this.description = this.student.description;
        this.monthlyPrice = this.$options.filters.replaceDotsWithCommas(parseFloat(this.student.monthlyPrice).toFixed(2));
      } else {
        this.id = null;
        this.phoneNumber = null;
        this.skype = null;
        this.description = null;
        this.monthlyPrice = null;
      }
    },
    onSubmit() {
      this.$v.$touch();

      let monthlyPriceString  =  replaceCommasWithDots(this.monthlyPrice);

      if (!this.$v.$error) {
        let result = {
          phoneNumber: this.phoneNumber,
          skype: this.skype,
          description: this.description,
          monthlyPrice: monthlyPriceString
        };

        this.$emit("save", result);
        this.visible = false;
      }
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onlyForCurrency($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      let monthlyPriceString = this.monthlyPrice + "";
      monthlyPriceString = replaceCommasWithDots(monthlyPriceString);

      // only allow number and one comma
      if ((keyCode < 48 || keyCode > 57) &&(keyCode !== 44 || monthlyPriceString.indexOf(".") != -1)) { // 46 is dot, 44 is comma
        $event.preventDefault();
      }
      
      if($event.target.selectionStart > monthlyPriceString.indexOf(".") && monthlyPriceString.indexOf(".") != -1){
        if (this.monthlyPrice != null && monthlyPriceString.indexOf(".") > -1 && monthlyPriceString.split(".")[1].length > 1) {
          $event.preventDefault();
        }
      }

      if($event.target.selectionStart == 0 && $event.key == 0){
          $event.preventDefault();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>

